export default __webpack_public_path__ + "static/media/POL.bd86ff75.png";